/* theme.js (hardened) */
(function () {
  "use strict";

  /* -------------------------
    Helpers / Safe utils
  -------------------------- */
  const $ = (sel, root = document) => {
    try {
      return root.querySelector(sel);
    } catch (e) {
      return null;
    }
  };
  const $$ = (sel, root = document) => {
    try {
      return Array.from(root.querySelectorAll(sel));
    } catch (e) {
      return [];
    }
  };
  const safeOn = (el, ev, fn, opts) => {
    if (!el || typeof el.addEventListener !== "function") return;
    el.addEventListener(ev, fn, opts);
  };
  const hasIO = () => typeof window.IntersectionObserver !== "undefined";

  // Debounce: użyj globalnego (z utility.js), a jeśli nie ma, daj poprawny fallback
  const debounce =
    window.debounce ||
    function debounce(fn, wait = 300) {
      let t;
      return function (...args) {
        const ctx = this;
        clearTimeout(t);
        t = setTimeout(() => {
          try {
            fn.apply(ctx, args);
          } catch (e) {
            console.warn("[debounce]", e);
          }
        }, wait);
      };
    };

  /* -------------------------
    Shopify editor
  -------------------------- */
  function editorShopifyEvent(t, e, i) {
    let n = !1;
    if (t.type.includes("shopify:section")) {
      if (
        e &&
        e.hasAttribute &&
        e.hasAttribute("data-section-id") &&
        e.getAttribute("data-section-id") === t.detail.sectionId
      ) {
        n = !0;
      }
    } else if (t.type.includes("shopify:block")) {
      n = t.target === e;
    }
    n && i && i(t);
  }
  window.editorShopifyEvent = window.editorShopifyEvent || editorShopifyEvent;

  /* -------------------------
    Shopify Currency Symbol
  -------------------------- */
  const currencySymbol = {
    AED: "د.إ",
    AFN: "؋",
    ALL: "L",
    AMD: "֏",
    ANG: "ƒ",
    AOA: "Kz",
    ARS: "$",
    AUD: "$",
    AWG: "ƒ",
    AZN: "₼",
    BAM: "KM",
    BBD: "$",
    BDT: "Tk",
    BGN: "лв",
    BHD: ".د.ب",
    BIF: "FBu",
    BMD: "$",
    BND: "$",
    BOB: "$b",
    BOV: "BOV",
    BRL: "R$",
    BSD: "$",
    BTC: "₿",
    BTN: "Nu.",
    BWP: "P",
    BYN: "Br",
    BYR: "Br",
    BZD: "BZ$",
    CAD: "$",
    CDF: "FC",
    CHE: "CHE",
    CHF: "CHF",
    CHW: "CHW",
    CLF: "CLF",
    CLP: "$",
    CNY: "¥",
    COP: "$",
    COU: "COU",
    CRC: "₡",
    CUC: "$",
    CUP: "₱",
    CVE: "$",
    CZK: "Kč",
    DJF: "Fdj",
    DKK: "kr",
    DOP: "RD$",
    DZD: "دج",
    EEK: "kr",
    EGP: "£",
    ERN: "Nfk",
    ETB: "Br",
    ETH: "Ξ",
    EUR: "€",
    FJD: "$",
    FKP: "£",
    GBP: "£",
    GEL: "₾",
    GGP: "£",
    GHC: "₵",
    GHS: "GH₵",
    GIP: "£",
    GMD: "D",
    GNF: "FG",
    GTQ: "Q",
    GYD: "$",
    HKD: "$",
    HNL: "L",
    HRK: "kn",
    HTG: "G",
    HUF: "Ft",
    IDR: "Rp",
    ILS: "₪",
    IMP: "£",
    INR: "₹",
    IQD: "ع.د",
    IRR: "﷼",
    ISK: "kr",
    JEP: "£",
    JMD: "J$",
    JOD: "JD",
    JPY: "¥",
    KES: "KSh",
    KGS: "лв",
    KHR: "៛",
    KMF: "CF",
    KPW: "₩",
    KRW: "₩",
    KWD: "KD",
    KYD: "$",
    KZT: "₸",
    LAK: "₭",
    LBP: "£",
    LKR: "₨",
    LRD: "$",
    LSL: "M",
    LTC: "Ł",
    LTL: "Lt",
    LVL: "Ls",
    LYD: "LD",
    MAD: "MAD",
    MDL: "lei",
    MGA: "Ar",
    MKD: "ден",
    MMK: "K",
    MNT: "₮",
    MOP: "MOP$",
    MRO: "UM",
    MRU: "UM",
    MUR: "₨",
    MVR: "Rf",
    MWK: "MK",
    MXN: "$",
    MXV: "MXV",
    MYR: "RM",
    MZN: "MT",
    NAD: "$",
    NGN: "₦",
    NIO: "C$",
    NOK: "kr",
    NPR: "₨",
    NZD: "$",
    OMR: "﷼",
    PAB: "B/.",
    PEN: "S/.",
    PGK: "K",
    PHP: "₱",
    PKR: "₨",
    PLN: "zł",
    PYG: "Gs",
    QAR: "﷼",
    RMB: "￥",
    RON: "lei",
    RSD: "Дин.",
    RUB: "₽",
    RWF: "R₣",
    SAR: "﷼",
    SBD: "$",
    SCR: "₨",
    SDG: "ج.س.",
    SEK: "kr",
    SGD: "S$",
    SHP: "£",
    SLL: "Le",
    SOS: "S",
    SRD: "$",
    SSP: "£",
    STD: "Db",
    STN: "Db",
    SVC: "$",
    SYP: "£",
    SZL: "E",
    THB: "฿",
    TJS: "SM",
    TMT: "T",
    TND: "د.ت",
    TOP: "T$",
    TRL: "₤",
    TRY: "₺",
    TTD: "TT$",
    TVD: "$",
    TWD: "NT$",
    TZS: "TSh",
    UAH: "₴",
    UGX: "USh",
    USD: "$",
    UYI: "UYI",
    UYU: "$U",
    UYW: "UYW",
    UZS: "лв",
    VEF: "Bs",
    VES: "Bs.S",
    VND: "₫",
    VUV: "VT",
    WST: "WS$",
    XAF: "FCFA",
    XBT: "Ƀ",
    XCD: "$",
    XOF: "CFA",
    XPF: "₣",
    XSU: "Sucre",
    XUA: "XUA",
    YER: "﷼",
    ZAR: "R",
    ZMW: "ZK",
    ZWD: "Z$",
    ZWL: "$",
  };

  // SAFETY: Shopify.currency może nie istnieć w niektórych webview / błędach loadu
  const activeCurrency =
    window.Shopify && Shopify.currency && Shopify.currency.active
      ? Shopify.currency.active
      : "PLN";

  const shopCurrencySymbol = currencySymbol[activeCurrency] || activeCurrency;

  // (opcjonalnie) expose, jak coś korzysta
  window.shopCurrencySymbol = window.shopCurrencySymbol || shopCurrencySymbol;

  /* -------------------------
    Get Sibling
  -------------------------- */
  const getSiblings = function (elem) {
    if (!elem || !elem.parentNode) return [];
    const siblings = [];
    let sibling = elem.parentNode.firstChild;
    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== elem) siblings.push(sibling);
      sibling = sibling.nextSibling;
    }
    return siblings;
  };

  /* -------------------------
    Slide Up / Down (guarded)
  -------------------------- */
  const slideUp = (target, time) => {
    if (!target) return;
    const duration = time ? time : 500;
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.boxSizing = "border-box";
    target.style.height = target.offsetHeight + "px";
    target.offsetHeight; // force reflow
    target.style.overflow = "hidden";
    target.style.height = 0;
    window.setTimeout(() => {
      target.style.display = "none";
      target.style.removeProperty("height");
      target.style.removeProperty("overflow");
      target.style.removeProperty("transition-duration");
      target.style.removeProperty("transition-property");
    }, duration);
  };

  const slideDown = (target, time) => {
    if (!target) return;
    let duration = time ? time : 500;
    target.style.removeProperty("display");
    let display = window.getComputedStyle(target).display;
    if (display === "none") display = "block";
    target.style.display = display;
    const height = target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.offsetHeight;
    target.style.boxSizing = "border-box";
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = height + "px";
    window.setTimeout(() => {
      target.style.removeProperty("height");
      target.style.removeProperty("overflow");
      target.style.removeProperty("transition-duration");
      target.style.removeProperty("transition-property");
    }, duration);
  };

  window.slideUp = window.slideUp || slideUp;
  window.slideDown = window.slideDown || slideDown;

  /* -------------------------
    activeClassAction (fixed: use currentTarget)
  -------------------------- */
  const activeClassAction = function (toggle, target) {
    const to = document.querySelector(toggle);
    const ta = document.querySelector(target);
    if (!to || !ta) return;

    safeOn(to, "click", function (e) {
      e.preventDefault();
      // U Ciebie było e.target (child), teraz jest zawsze kliknięty trigger
      const trigger = e.currentTarget;
      const isActive = trigger.classList.contains("active");
      trigger.classList.toggle("active", !isActive);
      ta.classList.toggle("active", !isActive);
    });

    safeOn(document, "click", function (event) {
      const toggleClass = toggle.replace(/\./, "");
      const targetClass = target.replace(/\./, "");

      const clickedToggle =
        event.target.closest(toggle) || event.target.classList.contains(toggleClass);
      const clickedTarget =
        event.target.closest(target) || event.target.classList.contains(targetClass);

      if (!clickedToggle && !clickedTarget) {
        to.classList.remove("active");
        ta.classList.remove("active");
      }
    });
  };
  window.activeClassAction = window.activeClassAction || activeClassAction;

  /* -------------------------
    TopOffset
  -------------------------- */
  function TopOffset(el) {
    if (!el || !el.getBoundingClientRect) return { top: 0 };
    let rect = el.getBoundingClientRect();
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop };
  }
  window.TopOffset = window.TopOffset || TopOffset;

  /* -------------------------
    fetchConfig
  -------------------------- */
  function fetchConfig(type = "json") {
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/${type}`,
      },
    };
  }
  window.fetchConfig = window.fetchConfig || fetchConfig;

  /* -------------------------
    initSectionVisiable (guarded)
  -------------------------- */
  const initSectionVisiable = function (elemnts) {
    if (!elemnts || !elemnts.element || typeof elemnts.callback !== "function") return;
    if (!hasIO()) {
      // fallback: odpal od razu
      elemnts.callback();
      return;
    }
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            elemnts.callback();
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: `0px 0px ${elemnts.margin || 0}px 0px` }
    );
    observer.observe(elemnts.element);
  };
  window.initSectionVisiable = window.initSectionVisiable || initSectionVisiable;

  /* -------------------------
    Focus helpers
  -------------------------- */
  function getFocusableElements(container) {
    if (!container) return [];
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }

  const trapFocusHandlers = {};

  function trapFocus(container, elementToFocus = container) {
    if (!container) return;

    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    if (!first || !last) return;

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      )
        return;

      document.addEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
      if (event.code.toUpperCase() !== "TAB") return;

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }

      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
    };

    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);

    try {
      (elementToFocus || container).focus();
    } catch (e) {}
  }

  function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);

    if (elementToFocus) {
      try {
        elementToFocus.focus();
      } catch (e) {}
    }
  }

  window.trapFocus = window.trapFocus || trapFocus;
  window.removeTrapFocus = window.removeTrapFocus || removeTrapFocus;

  function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector("summary");
    openDetailsElement.removeAttribute("open");
    if (summaryElement) summaryElement.focus();
  }

  /* -------------------------
    Details summary ARIA (guarded)
  -------------------------- */
  $$('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute("role", "button");
    summary.setAttribute("aria-expanded", "false");

    const sib = summary.nextElementSibling;
    if (sib && sib.getAttribute && sib.getAttribute("id")) {
      summary.setAttribute("aria-controls", sib.id);
    }

    safeOn(summary, "click", (event) => {
      const det = event.currentTarget.closest("details");
      const isOpen = det ? det.hasAttribute("open") : false;
      event.currentTarget.setAttribute("aria-expanded", (!isOpen).toString());
    });

    if (summary.closest("header-drawer")) return;

    if (summary.parentElement) {
      safeOn(summary.parentElement, "keyup", onKeyUpEscape);
    }
  });

  /* -------------------------
    focus-visible polyfill (ok)
  -------------------------- */
  try {
    document.querySelector(":focus-visible");
  } catch {
    focusVisiblePolyfill();
  }

  function focusVisiblePolyfill() {
    const navKeys = [
      "ARROWUP",
      "ARROWDOWN",
      "ARROWLEFT",
      "ARROWRIGHT",
      "TAB",
      "ENTER",
      "SPACE",
      "ESCAPE",
      "HOME",
      "END",
      "PAGEUP",
      "PAGEDOWN",
    ];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener("keydown", (event) => {
      if (navKeys.includes(event.code.toUpperCase())) mouseClick = false;
    });

    window.addEventListener("mousedown", () => {
      mouseClick = true;
    });

    window.addEventListener(
      "focus",
      () => {
        if (currentFocusedElement && currentFocusedElement.classList) {
          currentFocusedElement.classList.remove("focused");
        }
        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        if (currentFocusedElement && currentFocusedElement.classList) {
          currentFocusedElement.classList.add("focused");
        }
      },
      true
    );
  }

  /* -------------------------
    pauseAllMedia (FIXED: exported)
  -------------------------- */
  function pauseAllMedia() {
    $$(".js-youtube").forEach((video) => {
      try {
        video.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      } catch (e) {}
    });

    $$(".js-vimeo").forEach((video) => {
      try {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
      } catch (e) {}
    });

    $$("video").forEach((video) => {
      try {
        video.pause();
      } catch (e) {}
    });

    $$("product-model").forEach((model) => {
      try {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      } catch (e) {}
    });
  }
  window.pauseAllMedia = window.pauseAllMedia || pauseAllMedia;

  /* -------------------------
    QuantityInput (guarded)
  -------------------------- */
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector("input");
      if (!this.input) return;

      this.changeEvent = new Event("change", { bubbles: true });

      this.querySelectorAll("button").forEach((button) =>
        safeOn(button, "click", this.onButtonClick.bind(this))
      );
    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;

      if (event.target && event.target.name === "plus") this.input.stepUp();
      else this.input.stepDown();

      if (previousValue !== this.input.value) {
        this.input.dispatchEvent(this.changeEvent);
      }
    }
  }

  try {
    if (!customElements.get("quantity-input")) {
      customElements.define("quantity-input", QuantityInput);
    }
  } catch (e) {}

  /* -------------------------
    serializeForm (ok)
  -------------------------- */
  const serializeForm = (form) => {
    const obj = {};
    const formData = new FormData(form);

    for (const key of formData.keys()) {
      const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

      if (regex.test(key)) {
        obj.properties = obj.properties || {};
        obj.properties[regex.exec(key)[2]] = formData.get(key);
      } else {
        obj[key] = formData.get(key);
      }
    }

    return JSON.stringify(obj);
  };
  window.serializeForm = window.serializeForm || serializeForm;

  /* -------------------------
    Shopify Common JS (guarded)
  -------------------------- */
  if (typeof window.Shopify === "undefined") window.Shopify = {};

  Shopify.bind = function (fn, scope) {
    return function () {
      return fn.apply(scope, arguments);
    };
  };

  Shopify.setSelectorByValue = function (selector, value) {
    if (!selector || !selector.options) return -1;
    for (var i = 0, count = selector.options.length; i < count; i++) {
      var option = selector.options[i];
      if (value == option.value || value == option.innerHTML) {
        selector.selectedIndex = i;
        return i;
      }
    }
    return -1;
  };

  Shopify.addListener = function (target, eventName, callback) {
    if (!target) return;
    target.addEventListener
      ? target.addEventListener(eventName, callback, false)
      : target.attachEvent && target.attachEvent("on" + eventName, callback);
  };

  Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options["method"] || "post";
    var params = options["parameters"] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", params[key]);
      form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    options = options || {};
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

    if (!this.countryEl || !this.provinceEl) return;

    Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
  };

  Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      if (!this.countryEl) return;
      var value = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, value);
      this.countryHandler();
    },

    initProvince: function () {
      if (!this.provinceEl) return;
      var value = this.provinceEl.getAttribute("data-default");
      if (value && this.provinceEl.options && this.provinceEl.options.length > 0) {
        Shopify.setSelectorByValue(this.provinceEl, value);
      }
    },

    countryHandler: function () {
      if (!this.countryEl || !this.provinceEl) return;

      var opt = this.countryEl.options[this.countryEl.selectedIndex];
      if (!opt) return;

      var raw = opt.getAttribute("data-provinces");
      var provinces = [];
      try {
        provinces = raw ? JSON.parse(raw) : [];
      } catch (e) {
        provinces = [];
      }

      this.clearOptions(this.provinceEl);

      if (Array.isArray(provinces) && provinces.length === 0) {
        if (this.provinceContainer) this.provinceContainer.style.display = "none";
      } else {
        for (var i = 0; i < provinces.length; i++) {
          var o = document.createElement("option");
          o.value = provinces[i][0];
          o.innerHTML = provinces[i][1];
          this.provinceEl.appendChild(o);
        }
        if (this.provinceContainer) this.provinceContainer.style.display = "";
      }
    },

    clearOptions: function (selector) {
      if (!selector) return;
      while (selector.firstChild) selector.removeChild(selector.firstChild);
    },

    setOptions: function (selector, values) {
      if (!selector || !Array.isArray(values)) return;
      for (var i = 0; i < values.length; i++) {
        var opt = document.createElement("option");
        opt.value = values[i];
        opt.innerHTML = values[i];
        selector.appendChild(opt);
      }
    },
  };

  /* -------------------------
    ModalDialog (guarded)
  -------------------------- */
  class ModalDialog extends HTMLElement {
    constructor() {
      super();

      const closeBtn = this.querySelector('[id^="ModalClose-"]');
      if (closeBtn) {
        safeOn(closeBtn, "click", this.hide.bind(this));
      }

      safeOn(this, "keyup", (event) => {
        if (event.code.toUpperCase() === "ESCAPE") this.hide();
      });

      if (this.classList.contains("media-modal")) {
        safeOn(this, "pointerup", (event) => {
          if (
            event.pointerType === "mouse" &&
            !event.target.closest("deferred-media, product-model")
          ) {
            this.hide();
          }
        });
      } else {
        safeOn(this, "click", (event) => {
          if (event.target && event.target.nodeName === "MODAL-DIALOG") this.hide();
        });
      }
    }

    show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector(".template-popup");
      document.body.classList.add("overflow-hidden");
      this.setAttribute("open", "");
      if (popup && typeof popup.loadContent === "function") popup.loadContent();

      const dialog = this.querySelector('[role="dialog"]');
      trapFocus(this, dialog || this);
    }

    hide() {
      document.body.classList.remove("overflow-hidden");
      this.removeAttribute("open");
      removeTrapFocus(this.openedBy);

      if (typeof window.pauseAllMedia === "function") window.pauseAllMedia();
    }
  }

  try {
    if (!customElements.get("modal-dialog")) {
      customElements.define("modal-dialog", ModalDialog);
    }
  } catch (e) {}

  class ModalOpener extends HTMLElement {
    constructor() {
      super();
      const button = this.querySelector("button");
      if (!button) return;

      safeOn(button, "click", () => {
        const sel = this.getAttribute("data-modal");
        const modal = sel ? document.querySelector(sel) : null;
        if (modal && typeof modal.show === "function") modal.show(button);
      });
    }
  }

  try {
    if (!customElements.get("modal-opener")) {
      customElements.define("modal-opener", ModalOpener);
    }
  } catch (e) {}

  /* -------------------------
    DeferredMedia (guarded)
  -------------------------- */
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      safeOn(poster, "click", this.loadContent.bind(this));
    }

    loadContent(focus = true) {
      if (typeof window.pauseAllMedia === "function") window.pauseAllMedia();

      if (!this.getAttribute("loaded")) {
        const tpl = this.querySelector("template");
        if (!tpl || !tpl.content) return;

        const first = tpl.content.firstElementChild;
        if (!first) return;

        const content = document.createElement("div");
        content.appendChild(first.cloneNode(true));

        this.setAttribute("loaded", true);

        const deferred = content.querySelector("video, model-viewer, iframe");
        if (!deferred) return;

        const deferredElement = this.appendChild(deferred);
        if (focus) {
          try {
            deferredElement.focus();
          } catch (e) {}
        }

        if (
          deferredElement.nodeName === "VIDEO" &&
          deferredElement.getAttribute("autoplay")
        ) {
          // force autoplay for safari
          try {
            deferredElement.play();
          } catch (e) {}
        }
      }
    }
  }

  try {
    if (!customElements.get("deferred-media")) {
      customElements.define("deferred-media", DeferredMedia);
    }
  } catch (e) {}

  /* -------------------------
    Countdown timer (guarded)
  -------------------------- */
  class DataCountdown extends HTMLElement {
    constructor() {
      super();
      this.onCountDown();
    }

    onCountDown() {
      const CountDownElement = this.querySelector("[data-countdown]");
      if (!CountDownElement) return;

      const labels = window.countdown || {
        days: "dni",
        Hours: "godz.",
        minutes: "min",
        second: "sek",
        daysClass: "Days",
        HoursClass: "Hrs",
        minutesClass: "Min",
        secondClass: "Sec",
      };

      const countDownItem = (value, label, labelClass) => {
        return `<div class="countdown__item ${labelClass}"><span class="countdown__number">${value}</span> <span class="countdown__text">${label}</span></div>`;
      };

      const rawDate = CountDownElement.getAttribute("data-countdown");
      const date = rawDate ? new Date(rawDate).getTime() : NaN;
      if (!Number.isFinite(date)) return;

      const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;

      const countDownInterval = setInterval(function () {
        let currentTime = new Date().getTime();
        let timeDistance = date - currentTime;

        if (timeDistance < 0) timeDistance = 0;

        let daysValue = Math.floor(timeDistance / day);
        let hoursValue = Math.floor((timeDistance % day) / hour);
        let minutesValue = Math.floor((timeDistance % hour) / minute);
        let secondsValue = Math.floor((timeDistance % minute) / second);

        CountDownElement.innerHTML =
          countDownItem(daysValue, labels.days, labels.daysClass) +
          countDownItem(hoursValue, labels.Hours, labels.HoursClass) +
          countDownItem(minutesValue, labels.minutes, labels.minutesClass) +
          countDownItem(secondsValue, labels.second, labels.secondClass);

        if (date - currentTime <= 0) clearInterval(countDownInterval);
      }, 1000);
    }
  }

  try {
    if (!customElements.get("countdown-timer")) {
      customElements.define("countdown-timer", DataCountdown);
    }
  } catch (e) {}

  /* -------------------------
    Localization form (guarded)
  -------------------------- */
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector("button"),
        panel: this.querySelector("ul"),
      };

      if (!this.elements.button || !this.elements.panel || !this.elements.input) return;

      safeOn(this.elements.button, "click", this.openSelector.bind(this));
      safeOn(this.elements.button, "focusout", this.closeSelector.bind(this));
      safeOn(this, "keyup", this.onContainerKeyUp.bind(this));

      this.querySelectorAll("a").forEach((item) =>
        safeOn(item, "click", this.onItemClick.bind(this))
      );

      this.onHideDropdown = this.closeSelector.bind(this);
    }

    hidePanel() {
      this.elements.button.setAttribute("aria-expanded", "false");
      this.elements.panel.setAttribute("hidden", true);
      document.body.removeEventListener("click", this.onHideDropdown);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== "ESCAPE") return;
      this.hidePanel();
      try {
        this.elements.button.focus();
      } catch (e) {}
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector("form");
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      try {
        this.elements.button.focus();
      } catch (e) {}
      this.elements.panel.toggleAttribute("hidden");

      const expanded = this.elements.button.getAttribute("aria-expanded") === "false";
      this.elements.button.setAttribute("aria-expanded", expanded.toString());

      document.body.addEventListener("click", this.onHideDropdown);
    }

    closeSelector(event) {
      const shouldClose = event && event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
      if (shouldClose) this.hidePanel();

      const eventTarget = event && event.target ? event.target : null;
      if (eventTarget && !eventTarget.closest(".dropdown__open_label")) {
        this.hidePanel();
      }
    }
  }

  try {
    if (!customElements.get("localization-form")) {
      customElements.define("localization-form", LocalizationForm);
    }
  } catch (e) {}

  /* -------------------------
    ProductRecommendations (guarded + Swiper safe)
  -------------------------- */
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const load = async () => {
        const url = this.dataset.url;
        if (!url) return;

        try {
          const response = await fetch(url, { credentials: "same-origin" });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const text = await response.text();

          const html = document.createElement("div");
          html.innerHTML = text;

          const recSrc = html.querySelector("[grid-recommendation]");
          const recDest = this.querySelector("[grid-recommendation]");

          if (recSrc && recDest) {
            if (recSrc.innerHTML.trim().length) {
              recDest.innerHTML = recSrc.innerHTML;
            } else {
              // brak wyników
              if (this.parentElement) this.parentElement.classList.add("no-js-inline");
              if (this.children && this.children[0]) {
                this.children[0].classList.add("no-js-inline");
              }
              return;
            }
          }

          if (this.querySelector(".product__card")) {
            this.classList.add("product-recommendations--loaded");
          }

          const canUseSwiper = typeof window.Swiper !== "undefined";

          // complementary
          if (this.dataset.intent === "complementary") {
            if (!canUseSwiper) return;

            let sliderLoop = this.dataset.sliderLoop === "true";
            const el = this.querySelector(".complementory--slider");
            if (!el) return;

            new Swiper(el, {
              loop: sliderLoop,
              slidesPerView: 1,
              spaceBetween: 10,
              autoHeight: true,
              pagination: {
                el: this.querySelector(".swiper-pagination"),
                clickable: true,
              },
            });

            const wrap = this.querySelector(".complementary-slideshow--slider");
            if (wrap) wrap.classList.remove("no-js-inline");

            const det = this.querySelector("details");
            if (det) det.open = true;
          }

          // related
          if (this.dataset.intent === "related" && this.dataset.sliderEnable === "true") {
            if (!canUseSwiper) return;

            let sliderLoop = this.dataset.sliderLoop === "true";
            let sliderAutoplay = this.dataset.autoplay === "true";
            let autoPlayTime = parseInt(this.dataset.autoplayTime, 10);
            if (!Number.isFinite(autoPlayTime) || autoPlayTime <= 0) autoPlayTime = 4000;

            const container = this.querySelector(".productSlider");
            if (!container) return;

            const relatedProducts = new Swiper(container, {
              loop: sliderLoop,
              slidesPerView: parseInt(this.dataset.showMobile, 10) || 1,
              spaceBetween: 30,
              autoplay: sliderAutoplay ? { delay: autoPlayTime } : false,
              pagination: {
                el: this.querySelector(".swiper-pagination"),
                clickable: true,
                type: "fraction",
              },
              navigation: {
                nextEl: this.querySelector(".swiper-button-next"),
                prevEl: this.querySelector(".swiper-button-prev"),
              },
              breakpoints: {
                640: { slidesPerView: parseInt(this.dataset.showMobile, 10) || 1 },
                750: { slidesPerView: parseInt(this.dataset.showTablet, 10) || 1 },
                992: { slidesPerView: parseInt(this.dataset.showExtraLarge, 10) || 1 },
              },
            });

            if (sliderAutoplay) {
              safeOn(container, "mouseenter", () => {
                try {
                  relatedProducts.autoplay.stop();
                } catch (e) {}
              });
              safeOn(container, "mouseleave", () => {
                try {
                  relatedProducts.autoplay.start();
                } catch (e) {}
              });
            }
          }
        } catch (e) {
          console.warn("[product-recommendations] error:", e);
        }
      };

      // IO lazy load
      if (hasIO()) {
        const handleIntersection = (entries, observer) => {
          if (!entries[0] || !entries[0].isIntersecting) return;
          observer.unobserve(this);
          load();
        };

        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: "0px 0px 400px 0px",
        }).observe(this);
      } else {
        // fallback: odpal od razu
        load();
      }
    }
  }

  try {
    if (!customElements.get("product-recommendations")) {
      customElements.define("product-recommendations", ProductRecommendations);
    }
  } catch (e) {}

  /* -------------------------
    End
  -------------------------- */
})();
